import { cn } from "@/utils/cn";
import { memo } from "react";

interface HeartFilledIconProps {
  className?: string;
}

export const HeartFilledIcon = memo(function HeartFilledIcon({ className }: HeartFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn("fill-current", className)}
    >
      <path d="M17.1875 3C15.2516 3 13.5566 3.8325 12.5 5.23969C11.4434 3.8325 9.74844 3 7.8125 3C6.27146 3.00174 4.79404 3.61468 3.70436 4.70436C2.61468 5.79404 2.00174 7.27146 2 8.8125C2 15.375 11.7303 20.6869 12.1447 20.9062C12.2539 20.965 12.376 20.9958 12.5 20.9958C12.624 20.9958 12.7461 20.965 12.8553 20.9062C13.2697 20.6869 23 15.375 23 8.8125C22.9983 7.27146 22.3853 5.79404 21.2956 4.70436C20.206 3.61468 18.7285 3.00174 17.1875 3Z" />
    </svg>
  );
});
